export const Config = {
  V2: { FILES_URL: 'https://d2o01n7jpqohft.cloudfront.net' },
  CODEMASH: {
    PROJECT_ID: process.env.REACT_APP_CODEMASH_PROJECT_ID,
    SECRET_KEY: process.env.REACT_APP_CODEMASH_SECRET_KEY,
    FILE_ACCOUNT_ID: process.env.REACT_APP_CODEMASH_FILE_ID,
    DATABASE_ID: process.env.REACT_APP_DATABASE_ID || 'b783efc5-a424-47ff-8513-7bb5078151b2',
  },
  SHOW_LOGS: true,
  MAPS_API_KEY: process.env.REACT_APP_MAPS_API_KEY,
  DEFAULTS: {
    LANGUAGE: 'en',
    PAGE_SIZE: 100,
    TAXONOMY_PAGE_SIZE: 100,
    ROUTE_NAME: 'Orders',
    ORDER_PRIORITY_PRICE: 2,
  },
  // LANGUAGES: { LT: 'lt', EN: 'en', RU: 'ru' },
  AVAILABLE_LANGUAGES: [
    'en',
    'bg',
    'de',
    'dk',
    'ee',
    'es',
    'fi',
    'lt',
    'lv',
    'no',
    'pl',
    'ro',
    'ru',
    'se',
  ],
  ORDERED_AVAILABLE_LANGUAGES: [
    'en',
    'bg',
    'de',
    'dk',
    'ee',
    'es',
    'fi',
    'lt',
    'lv',
    'no',
    'pl',
    'ro',
    'ru',
    'se',
  ],
  ROLES: {
    ADMIN: 'SysAdmin',
    KITCHEN: 'kitchen',
    BAR: 'bar',
    RESTAURANT: 'restaurant',
    WAITER: 'waiter',
    AUTHENTICATED: 'RestaurantAdmin',
    UNAUTHENTICATED: 'Unauthenticated',
    COMPANY: 'company',
  },
  DATA: {
    LOADING_STATUS: {
      NOT_LOADING: 0,
      INITIAL_LOAD: 1,
      PAGING_LOAD: 2,
    },
    COLLECTIONS: {
      ORDERS: 'orders',
      CLIENTS: 'clients',
      COMPANY_CLIENTS: 'company-clients',
      REVIEWS: 'client-reviews',
      COMPANY: 'company',
      PRODUCTS: 'products',
      RESTAURANTS: 'restaurants',
      CLASSIFICATIONS: 'product-classifications',
      MENU: 'menu',
      RESTAURANT_WORKING_SCHEDULES: 'restaurant-working-schedules',
      TABLES: 'tables',
      EMPLOYEES: 'employees',
      DRIVERS: 'drivers',
      PRODUCT_CATEGORIES: 'product-categories',
      PRODUCT_SCHEDULE: 'product-schedule',
      COMPANY_GROUPS: 'company-groups',
      COMPANY_CLIENT_GROUPS: 'company-clients',
      USER_PROFILE: 'users-profile',
      WEB_USERS: 'web-admin-users',
      VARIATION_TEMPLATES: 'variation-templates',
      VARIATION_JOINS: 'variation-joins',
      PRODUCT_VARIATION_JOINS: 'product-variation-joins',
      PRODUCT_VARIATIONS: 'product-variations',
      DISCOUNTS: 'discounts',
      COUNTERS: 'counters',
      PRODUCT_STOCK: 'product-stock',
      STOCK_HISTORY: 'stock-history',
      RKEEPER_CREDENTIALS: 'rkeeper-credentials',
      IIKO_CREDENTIALS: 'iiko-credentials',
      PAYMENT_ACCOUNTS: 'payment-accounts',
      DELIVERY_SETTINGS: 'delivery-settings',
      DELIVERY_RESTAURANTS: 'delivery-restaurants',
      COMPANY_DASHBOARD: 'company-dashboard',
      COUPONS: 'coupons',
      PRODUCT_SHEET_IMPORTS: 'product-sheet-imports',
      RESTAURANT_EVENTS: 'restaurant-events',
      RESTAURANT_PROMOTIONS: 'restaurant-promotions',
    },
    TAXONOMIES: { CITIES: 'cities' },
    AGGREGATES: {
      PRODUCT_CATEGORIES_LIST: '5e2c10ce-9326-4882-a788-321214c74090',
      PRODUCT_CATEGORIES_V2: '941f04a5-a473-4736-913b-92cb806c92a7',
      GET_TABLE_SECTIONS: '925261d8-04e0-4605-a40c-4bf50b911cc6',
      GET_CLIENTS: '1a3dffb3-51e3-40ef-9a44-dcd74f2c3556',
      GET_CLIENT_ORDERS: '85634410-8c00-40b2-99ad-eb1fb073144e',
      GET_ORDERS: '635c778a-d4e0-4be1-bdea-65f52c341a74',
      GET_IN_PROGRESS_ORDERS: 'd2357c40-093d-46cd-be25-1c4a101e1cc9',
      GET_MENUS: 'd7c5f7b0-66c3-4b26-95ee-ee991ede9eb2',
      GET_PAYMENT_ACCOUNTS: '87962418-ad1c-4452-963d-dd7964d10488',
      GET_ORDERS_FROM_DATE: '649c3326-1531-4a4f-898d-f91267988099',
      GET_CLIENTS_FROM_DATE: '996e54f4-3549-434b-a6d8-383d4d44c12f',
      GET_ORDER_BY_ID: 'af6ed4b4-bf9c-4bfd-b158-6f0c2ea66d91',
      GET_COMPANY_INVOICES: '60c58875-632a-44be-b4c9-75f474e04fc5',
      GET_COMPANY_INVOICE_DETAILS: '2e05832c-97b0-4155-8acc-d4070a7844cc',
      GET_RESTAURANT_INVOICES: 'a0af977c-838b-4bae-bf8d-10bb68e9a909',
      GET_STOCK_HISTORY: 'f106448f-b03c-407c-8512-74f72dc1ab9c',
      GET_REVIEWS: '409f9d3d-6574-45c8-8792-93f7f6a4aef3',
      GET_REVIEW_DETAILS: '41f58ecf-bcde-46e0-b493-ffc85eb9dc7f',
      GET_WAITERS: 'b0c0ec4f-320f-4e86-9b7f-f3ef9a207d3f',
      GET_TABLES: '1af22538-684d-4411-86b5-e8bbae2b9322',
      GET_TABLE_BY_ID: '1175a5fd-9835-4a0e-ba42-989b17598c25',
      GET_WAITERS_FROM_SYNCED_ORDERS: '6da635eb-7f70-4861-8e65-7bce43325391',
      GET_RESTAURANT_PAYMENTS: '95609dd8-1b65-4ea4-bf02-06d60aedd22e',
      GET_RESTAURANT_EMPLOYEE_PAYMENTS: 'bd572340-4fab-4937-a502-1284e582cb01',
      GET_ALL_COMPANY_PRODUCTS: '61b885ca-eca5-4772-ae5e-d6ae6359b789',
      GET_ALL_COMPANY_CATEGORIES: 'bd70c85b-459d-46eb-a52c-6f077708e138',
      GET_PRODUCTS_LIST: 'e1000722-9144-46ed-80db-91bf90340b54',
      GET_DELIVERY_RESTAURANTS: 'df975b9f-17ed-4b00-b08c-cb78309042bd',
      GET_VARIATION_TEMPLATE_ATTACHED_PRODUCTS: '80ed7efb-ae29-4fa6-b613-abea9eb7dabb',
      GET_ALL_VARIATION_TEMPLATES: '87f21a75-af74-414c-b556-1c350f2800ed',
    },
    FUNCTIONS: {
      SYNC_PRODUCTS: 'd3bf898e-8406-4970-94a3-e7b1d15a7587',
      PAY_RKEEPER_ORDER: 'd8ff544b-0a64-41ce-a649-f085932ebb9f',
      EXPORT_CSV: '17574a24-9e78-462b-b6f4-13d46b66994a',
      SAVE_RKEEPER_CREDENTIALS: 'ca5951e1-5f3f-4c75-a3b3-bd6cb17f1a53',
      GET_RKEEPER_CREDENTIALS_SETUP: 'e2a2fd6b-83c0-4664-93b9-5599f487da7e',
      SAVE_PAYMENT_ACCOUNT: 'c54f2422-9b3f-46b0-810e-7c0eb86d3b02',
      UPDATE_ORDER_FIELDS: 'caacbf39-ea9d-402f-ad74-e6fb85e1b0b2',
      UPDATE_RESTRICTED_RESOURCES: '51135141-0c88-4894-8f98-8dcbb744957d',
    },
    TERMS_AND_CONDITIONS_ID: '602c3beb001662269334e846',
    VARIATION_TYPES: [
      { label: 'One slection', value: 'one_selection' },
      { label: 'Multi selection with max options', value: 'multi_selection_max' },
    ],
    ORDER_LINE_TYPES: {
      ADD: 'Add',
      PRIORITY: 'Priority',
      REFUND: 'Refund',
    },
    ORDER_PAYMENT_STATUS: {
      PENDING: 'pending',
      ORDERED: 'ordered',
    },
    PAYMENT_METHOD: {
      IN_APP: 'App_Card',
      IN_RESTAURANT: 'In_Restaurant',
    },
    PAYMENT_TYPE: {
      CARD: 'Card',
      CASH: 'In_Restaurant',
      BANK: 'Bank',
    },
    FILTER_HIDDEN_OPTIONS: [
      { label: 'Show all', value: 'all' },
      { label: 'Show hidden', value: 'hidden' },
      { label: 'Show visible', value: 'visible' },
    ],
  },
  CODE: { RENAME_IT: { RENAME_IT: 'bb0dab89-5f23-4fce-a4b7-f4e11f2e54c3' } },
};
